import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import closeIcon from "../../../src/common/assets/images/close-icon.png";
import InfoOutlinedIcon from "@mui/icons-material/Info";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import undo_icon from "../../common/assets/images/undo.png";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import SearchIcon from "@mui/icons-material/Search";
import LdsRoller from "../../utils/LdsRoller";
import "./NudgingCard.css";
import { useSelector, useDispatch } from "react-redux";
import {
  setFromNudgingScreen,
  nudgingActionInfoAPI,
  setCodesForDelete,
  setVisibleNudgeCount,
} from "./NudgingSlicer";
import {
  setActiveIcon,
  setActiveTab,
  setRawSearchQuery,
} from "../CodeBook/redux/CodeBookSlicer";
import { setDocumentationCard,setCodeBookCard } from "../pages/Coder/redux/CoderSlicer";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { setAIJustificationData } from "../DocumentViewer/redux/DocumentViewerSlicer";

export default function NudgingCard({
  onClose,
  onViewSource,
  diagnosisStates,
  setDiagnosisStates,
  acceptedCodes,
  setAcceptedCodes,
  saveToHistory,
}) {
  const dispatch = useDispatch();
  const UNDO_TIME = 30;
  const { loading, data, error } = useSelector(
    (state) => state.nudging.nudgingEvaluationResponse,
  );
  const { fromNudgingScreen } = useSelector((state) => state.nudging);
  const { codeBookCard } = useSelector((state) => state.coder);
  const {
    loading: nudgingSessionResponseLoading,
    data: nudgingSessionResponseData,
    error: nudgingSessionResponseError,
  } = useSelector((state) => state.nudging.nudgingSessionResponse);
  const [expandedId, setExpandedId] = useState(null);
  const [outOfScopePage, setOutOfScopePage] = useState(0);
  const [partialPage, setPartialPage] = useState(0);
  const [revenuePage, setRevenuePage] = useState(0);
  const [dismissedNudges, setDismissedNudges] = useState({});
  const [undoTimers, setUndoTimers] = useState({});
  const [dismissedCodes, setDismissedCodes] = useState({});
  const location = useLocation();
  const [acceptingId, setAcceptingId] = useState(null);
  const isCodeAssistRoute =
    location.pathname.toLowerCase().includes("code-assist") ||
    location.pathname.toLowerCase().includes("auditor-codeassist-screen");

  const coderReviewDataOutOfScope = data?.data
    ?.coder_review_required_out_off_scope || {
    codes: [],
    count_of_out_off_scope: 0,
  };

  const coderReviewDataPartialScope = data?.data
    ?.coder_review_required_partial || {
    codes: [],
    count_of_partial: 0,
  };

  const coderReviewDataRevenueOptimization = data?.data
    ?.revenue_optimization || {
    codes: [],
    count_of_revenue_optimization_nudge: 0,
  };

  const outOfScopeCodes = Array.isArray(coderReviewDataOutOfScope?.codes)
    ? coderReviewDataOutOfScope.codes
    : [];

  const partialCodes = Array.isArray(coderReviewDataPartialScope?.codes)
    ? coderReviewDataPartialScope.codes
    : [];
  const revenueCodes = Array.isArray(coderReviewDataRevenueOptimization?.nudges)
    ? coderReviewDataRevenueOptimization.nudges
    : [];

const filterAcceptedCodes = (codes, nudgeId) => {
  const acceptedEntries = Object.entries(acceptedCodes || {});

  if (acceptedEntries.length === 0) {
    return codes;
  }

  return codes?.filter((codeItem) => {
    const apiCode = codeItem?.code_assigned;

    return !acceptedEntries.some(([acceptedCode, meta]) => {
      if (meta?.isProcedure) {
        return acceptedCode === apiCode;
      }

      const normalizedAcceptedCode = ["1", "2"]?.includes(acceptedCode?.[1])
        ? acceptedCode?.slice(2)
        : acceptedCode?.slice(1);

      return normalizedAcceptedCode === apiCode;
    });
  });
};

  const filteredOutOfScopeCodes = filterAcceptedCodes(
    outOfScopeCodes,
    "out_of_scope_code",
  );

  const filteredPartialCodes = filterAcceptedCodes(
    partialCodes,
    "partial_match_code",
  );

  const filteredRevenueCodes = filterAcceptedCodes(
    revenueCodes,
    "revenue-optimization",
  );

  const visibleOutOfScopeCodes = filteredOutOfScopeCodes.filter(
    (code) => !dismissedCodes[code?.code_assigned],
  );

  const visiblePartialCodes = filteredPartialCodes.filter(
    (code) => !dismissedCodes[code?.code_assigned],
  );

  const visibleRevenueCodes = filteredRevenueCodes.filter(
    (code) => !dismissedCodes[code?.code_assigned],
  );

  useEffect(() => {
    if (
      revenuePage >= visibleRevenueCodes.length &&
      visibleRevenueCodes.length > 0
    ) {
      setRevenuePage(visibleRevenueCodes.length - 1);
    }

    if (visibleRevenueCodes.length === 0) {
      setRevenuePage(0);
    }
  }, [visibleRevenueCodes.length, revenuePage]);
  // 3/2,2/1 issue 
    useEffect(() => {
    if (
      outOfScopePage >= visibleOutOfScopeCodes.length &&
      visibleOutOfScopeCodes.length > 0
    ) {
      setOutOfScopePage(visibleOutOfScopeCodes.length - 1);
    }
    if (visibleOutOfScopeCodes.length === 0) {
      setOutOfScopePage(0);
    }
  }, [visibleOutOfScopeCodes.length, outOfScopePage]);

  useEffect(() => {
    if (
      partialPage >= visiblePartialCodes.length &&
      visiblePartialCodes.length > 0
    ) {
      setPartialPage(visiblePartialCodes.length - 1);
    }
    if (visiblePartialCodes.length === 0) {
      setPartialPage(0);
    }
  }, [visiblePartialCodes.length, partialPage]);
  ////////////////////////////////////////////////
  const outOfScopeCount = filteredOutOfScopeCodes?.length;
  const partialCount = filteredPartialCodes?.length;
  const revenueCount = filteredRevenueCodes?.length;

  const outOfScopeNudges = [
    {
      id: "out_of_scope_code",
      theme: "review",
      icon: <AssignmentTurnedInOutlinedIcon />,
      title: "Coder Review Required",
      onlyCoderRoute: true,
      reviewType: "out_of_scope_code",
      codes: visibleOutOfScopeCodes,
      count: visibleOutOfScopeCodes.length,
      reason: "Out-Of-Scope Code Assigned",
      evidenceLabel: "EVIDENCE FROM DOCUMENTATION",
      suggestedAction:
        "Review the assigned diagnosis before confirming the DRG.",
      showViewSource: true,
    },
  ];

  const partialScopeNudges = [
    {
      id: "partial_match_code",
      theme: "review",
      icon: <AssignmentTurnedInOutlinedIcon />,
      title: "Coder Review Required",
      onlyCoderRoute: true,
      reviewType: "partial_match_code",
      codes: visiblePartialCodes,
      count: visiblePartialCodes.length,
      reason: "Partial Match Code Assigned",
      evidenceLabel: "EVIDENCE FROM DOCUMENTATION",
      suggestedAction:
        "Review the assigned diagnosis before confirming the DRG.",
      showViewSource: true,
    },
  ];
  const dismissedRevenueNudge = dismissedNudges["revenue-optimization"];

const currentRevenueCode =
  dismissedRevenueNudge?.dismissedCode ||
  visibleRevenueCodes?.[revenuePage] ||
  null;

  const revenueNudges = [
    {
      id: "revenue-optimization",
      theme: "revenue",
      icon: <TrendingUpIcon />,
      title: "Revenue Optimisation Opportunity",
      onlyCodeAssist: true,

      codes: visibleRevenueCodes,
      count: visibleRevenueCodes.length,
      reviewType: "revenue-optimization",
      currentDrg:
        currentRevenueCode?.current_drg ||
        currentRevenueCode?.currentDrg ||
        "N/A",

      suggestedDrg:
        currentRevenueCode?.suggested_drg ||
        currentRevenueCode?.suggestedDrg ||
        "N/A",

      estimatedIncrease:
        currentRevenueCode?.revenue_difference ||
        currentRevenueCode?.revenue_difference ||
        "",

    reason: currentRevenueCode?.reason || "",
    evidenceLabel: "Evidence:",
    evidence:
      currentRevenueCode?.evidence ||
      currentRevenueCode?.evidence_from_documentation ||
      "",
    suggestedAction:
      currentRevenueCode?.suggested_action || currentRevenueCode?.suggestedAction || "",
    },
  ];

  const dummyNudges = [
    ...outOfScopeNudges,
    ...partialScopeNudges,
    ...revenueNudges,

    // {
    //   id: "combo",
    //   theme: "combo",
    //   icon: <SearchIcon />,
    //   title: "Common Code Combination",
    //   onlyCodeAssist: true,
    //   currentCode: "I21",
    //   currentCodeDescription: "Acute Myocardial Infarction",
    //   suggestedCode: "E11",
    //   suggestedCodeDescription: "Type 2 Diabetes Mellitus",
    //   reason:
    //     "These diagnoses are frequently coded together in similar clinical episodes.",
    //   evidenceLabel: "Evidence:",
    //   evidence: "Historical patterns and documentation support this addition.",
    //   suggestedAction: "Review and determine if applicable.",
    //   nudge_code: "E11",
    //   nudge_subtype: "common_code_combination",
    //   trigger_code: "",
    // },
  ];

  const visibleNudges = dummyNudges.filter((item) => {
    if (item.onlyCodeAssist && !isCodeAssistRoute) {
      return false;
    }

    if (item.onlyCoderRoute && isCodeAssistRoute) {
      return false;
    }

    return true;
  });

  const getCurrentPage = (item) => {
    if (item.reviewType === "out_of_scope_code") {
      return outOfScopePage;
    }

    if (item.reviewType === "partial_match_code") {
      return partialPage;
    }

    if (item.id === "revenue-optimization") {
      return revenuePage;
    }
    return 0;
  };

  const setCurrentPage = (item, page) => {
    if (item.reviewType === "out_of_scope_code") {
      setOutOfScopePage(page);
    }
    if (item.reviewType === "partial_match_code") {
      setPartialPage(page);
    }
    if (item.reviewType === "revenue-optimization") {
      setRevenuePage(page);
    }
  };

  const isLastHCPLineIDPresent = sessionStorage.getItem("last_hcp_line_id");
  const handleCodeClick = async (action, item, selectedCode = null) => {
    if (action === "accept") setAcceptingId(item.id);
    try {
      const currentState = diagnosisStates;

      const normalizeCode = (code = "") =>
        ["1", "2"].includes(code?.[1]) ? code?.slice(2) : code?.slice(1);

      const allPrincipalCodes =
        currentState?.principal?.map((item) => normalizeCode(item?.code)) || [];

      const allAdditionalCodes =
        currentState?.additional?.map((item) => normalizeCode(item?.code)) ||
        [];

      const allProcedureCodes =
        currentState?.procedure?.map((item) => item?.code) || [];

      const nudgingActionInfoAPIPayload = {
        hcp_line_id: isLastHCPLineIDPresent,
        action,
        nudging_session_id:
          nudgingSessionResponseData?.data?.nudging_session_id,

        principal_diagnosis_code: allPrincipalCodes,
        additional_diagnosis: allAdditionalCodes,
        procedure_codes: allProcedureCodes,
        nudge_info: [
          {
            trigger_code:
              location?.pathname !== "/coder" ? selectedCode?.trigger_code : "",
            nudge_code: selectedCode?.code_assigned || "",
            nudge_subtype:
              location.pathname === "/coder" ? item?.reviewType : "",
          },
        ],

        nudge_type:
          location.pathname === "/coder"
            ? "coder_review_required"
            : "revenue_optimization_opportunity",
      };
      const actionResult = await dispatch(
        nudgingActionInfoAPI(nudgingActionInfoAPIPayload),
      );

      if (!actionResult?.payload?.data) {
        console.warn("No data returned from nudging action API");
        return;
      }

      const responseData = actionResult.payload.data;
      const codeToSend = responseData?.code || "";
      const codeTypeToSend = responseData?.code_type || "";
      const codeEvidenceToSend = responseData?.evidence || "";
      const codeDocumentIdToSend = responseData?.document_name || "";

      const codeJustificationToSend = responseData?.justification || "";

      if (action === "view_source") {
        // No evidence and no document
        if (!codeEvidenceToSend && !codeDocumentIdToSend) {
          toast.error("AI evidence and document are not available.");
          return;
        }

        const aiData = {
          code: codeToSend,
          justification: codeJustificationToSend,
          evidence: codeEvidenceToSend,
          document_name: codeDocumentIdToSend,
        };

        dispatch(setAIJustificationData(aiData));
        dispatch(setDocumentationCard(true));

        return;
      }

      if (action === "view_codebook") {
        if (!codeToSend) {
          console.warn("No code returned from nudging action API");
          return;
        }
        // Only open Codebook if it is currently closed — don't touch it if already open
        if (!codeBookCard) {
          dispatch(setCodeBookCard(true));
        }
        dispatch(setActiveIcon("Tabular"));
        setTimeout(() => {
          dispatch(setRawSearchQuery(codeToSend));
        }, 100);

        if (codeTypeToSend === "diagnosis") {
          dispatch(setActiveTab("ICD 10 AM Tabular"));
        } else if (codeTypeToSend === "procedure") {
          dispatch(setActiveTab("ACHI Tabular"));
        }

        return;
      }

      if (action === "accept") {
        if (action === "accept") {
          if (
    item?.reviewType === "revenue-optimization" &&
    responseData?.action === "Replace"
  ) {
    const triggerCode = responseData?.trigger_code;

    const newCode = Array.isArray(responseData?.nudge_code)
      ? responseData.nudge_code[0]
      : responseData?.nudge_code;

    const newDescription = Array.isArray(responseData?.nudge_code_description)
      ? responseData.nudge_code_description[0]
      : responseData?.nudge_code_description;

    if (triggerCode && newCode) {
      replaceDiagnosisCode(triggerCode, newCode, newDescription);
    }

    saveToHistory();
    return;
  }

          if (
            item?.reviewType === "revenue-optimization" &&
            responseData?.action === "Add"
          ) {
            updateDiagnosisStateFromNudge(responseData);

            saveToHistory();
            return;
          }

          // existing accept logic...
        }
        const allPrincipalCodes =
          currentState?.principal?.map((item) => item?.code) || [];
        const allAdditionalCodes =
          currentState?.additional?.map((item) => item?.code) || [];
        const allProcedureCodes =
          currentState?.procedure?.map((item) => item?.code) || [];

        const allCodes = [
          ...allPrincipalCodes,
          ...allAdditionalCodes,
          ...allProcedureCodes,
        ];

        const matchedCode = allCodes?.find((item) => {
          if (!item) return false;

          // Procedure codes are stored raw — compare directly, no COF/cluster stripping.
          if (allProcedureCodes.includes(item)) {
            return item === selectedCode?.code_assigned;
          }

          const normalizedCode = ["1", "2"].includes(item?.[1])
            ? item?.slice(2)
            : item?.slice(1);
          return normalizedCode === selectedCode?.code_assigned;
        });

        const isProcedureCode = allProcedureCodes.includes(matchedCode);

saveToHistory();
setAcceptedCodes((prev) => ({
  ...prev,
  [matchedCode]: { isProcedure: isProcedureCode },
}));
dispatch(setFromNudgingScreen(true));
return;
      }

      if (action === "dismiss") {
        saveToHistory();
        dispatch(setCodesForDelete(selectedCode?.code_assigned));
      }
    } catch (error) {
      console.error("Error handling code action:", error);
      toast.error("Something went wrong while processing the action.");
    }
    finally {
      if (action === "accept") setAcceptingId(null);
    }
  };

  const handleDismissNudge = (item, currentCode) => {
    if (!currentCode?.code_assigned) return;

    const nudgeId = item.id;
    const codeId = currentCode.code_assigned;

    if (dismissedNudges[nudgeId]) {
      return;
    }

    // Remove THIS CODE from the UI
    setDismissedCodes((prev) => ({
      ...prev,
      [codeId]: currentCode,
    }));

    // Remember which code belongs to this Undo
    setDismissedNudges((prev) => ({
      ...prev,
      [nudgeId]: {
        ...item,
        dismissedCode: currentCode,
      },
    }));

    // Start 30 second Undo timer
    setUndoTimers((prev) => ({
      ...prev,
      [nudgeId]: UNDO_TIME,
    }));

    handleCodeClick("dismiss", item, currentCode);
  };

  const handleUndoNudge = (item) => {
    const nudgeId = item.id;
    const dismissedItem = dismissedNudges[nudgeId];

    if (!dismissedItem?.dismissedCode) {
      return;
    }

    const codeId = dismissedItem.dismissedCode.code_assigned;

    // Restore THIS code
    setDismissedCodes((prev) => {
      const updated = { ...prev };
      delete updated[codeId];
      return updated;
    });

    // Remove dismissed state
    setDismissedNudges((prev) => {
      const updated = { ...prev };
      delete updated[nudgeId];
      return updated;
    });

    // Remove timer
    setUndoTimers((prev) => {
      const updated = { ...prev };
      delete updated[nudgeId];
      return updated;
    });
  };
  const getBaseCode = (code = "") => {
  if (!code) return "";

  return ["1", "2"].includes(code?.[1])
    ? code.slice(2)
    : code.slice(1);
};

const getCodePrefix = (code = "") => {
  if (!code) return "";

  const baseCode = getBaseCode(code);
    const sendEightEvenWhenZeroCode = code.slice(0, code.length - baseCode.length);
   const result = String(sendEightEvenWhenZeroCode).replace(/^0/, "8");
    return result;
  };

const replaceDiagnosisCode = (triggerCode, newCode, newDescription) => {
  if (!triggerCode || !newCode) return;

  setDiagnosisStates((prev) => {
    const updated = { ...prev };

    ["principal", "additional", "procedure"].forEach((type) => {
      if (!Array.isArray(updated[type])) return;

      updated[type] = updated[type].map((item) => {
        if (!item?.code) return item;

        const normalizedCode = getBaseCode(item.code);

        if (normalizedCode === triggerCode) {
          const prefix = getCodePrefix(item.code);
          return {
            ...item,
            code: `${prefix}${newCode}`,
            ...(newDescription !== undefined && { description: newDescription }),
          };
        }

        return item;
      });
    });

    return updated;
  });
};

const updateDiagnosisStateFromNudge = (responseData) => {
  const triggerCode = responseData?.trigger_code;

  const nudgeCodes = Array.isArray(responseData?.nudge_code)
    ? responseData.nudge_code
    : responseData?.nudge_code
      ? [responseData.nudge_code]
      : [];

  const nudgeDescriptions = Array.isArray(responseData?.nudge_code_description)
    ? responseData.nudge_code_description
    : responseData?.nudge_code_description
      ? [responseData.nudge_code_description]
      : [];

  const fallbackDescription =
    responseData?.description ||
    responseData?.code_description ||
    "";

  if (!triggerCode || nudgeCodes.length === 0) {
    return;
  }

  setDiagnosisStates((prev) => {
    const updated = { ...prev };
    let codesToAddToAdditional = null;

    ["principal", "additional"].forEach((type) => {
      if (!Array.isArray(updated[type])) return;

      const items = [...updated[type]];

      const triggerIndex = items.findIndex((item) => {
        if (!item?.code) return false;
        return getBaseCode(item.code) === triggerCode;
      });

      if (triggerIndex === -1) return;

      const existingCode = items[triggerIndex]?.code || "";
      const prefix = getCodePrefix(existingCode);

      if (responseData?.action === "Replace") {
        items[triggerIndex] = {
          ...items[triggerIndex],
          code: `${prefix}${nudgeCodes[0]}`,
          description:
            nudgeDescriptions[0] || fallbackDescription || items[triggerIndex]?.description,
        };
        updated[type] = items;
        return;
      }

      if (responseData?.action === "Add") {
        const newItems = nudgeCodes.map((code, idx) => ({
          code: `${prefix}${code}`,
          description: nudgeDescriptions[idx] || fallbackDescription,
        }));

        if (type === "principal") {
          codesToAddToAdditional = newItems;
          return;
        }

        items.splice(triggerIndex + 1, 0, ...newItems);
        updated[type] = items;
      }
    });

    if (codesToAddToAdditional) {
      updated.additional = [
        ...codesToAddToAdditional,
        ...(updated.additional || []),
      ];
    }

    return updated;
  });
};

  useEffect(() => {
    const interval = setInterval(() => {
      setUndoTimers((prev) => {
        const updated = { ...prev };

        Object.keys(updated).forEach((nudgeId) => {
          if (updated[nudgeId] <= 1) {
            // Timer finished.
            // Remove ONLY the Undo timer.
            // Keep dismissedCodes so the code stays removed.
            delete updated[nudgeId];

            // Remove the temporary Undo state
            setDismissedNudges((dismissedPrev) => {
              const dismissedUpdated = { ...dismissedPrev };
              delete dismissedUpdated[nudgeId];
              return dismissedUpdated;
            });
          } else {
            updated[nudgeId] -= 1;
          }
        });

        return updated;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);
  const shouldShowUndo = (item) => {
    return (
      (item.reviewType === "out_of_scope_code" ||
        item.reviewType === "partial_match_code" ||
        item.reviewType === "revenue-optimization") &&
      undoTimers[item.id] != null
    );
  };
useEffect(() => {
  setDismissedCodes((prev) => {
    const activeCodeIds = new Set(
      Object.values(dismissedNudges)
        .map((n) => n?.dismissedCode?.code_assigned)
        .filter(Boolean),
    );

    const updated = {};
    Object.entries(prev).forEach(([codeId, val]) => {
      if (activeCodeIds.has(codeId)) {
        updated[codeId] = val; 
      }
    });
    return updated;
  });
}, [data]);
const totalVisibleNudgeCount =
  visibleOutOfScopeCodes.length +
  visiblePartialCodes.length +
  visibleRevenueCodes.length;

useEffect(() => {
  dispatch(setVisibleNudgeCount(totalVisibleNudgeCount));
}, [totalVisibleNudgeCount]);
const normalizeDiagnosisCode = (code = "") =>
  ["1", "2"].includes(code?.[1]) ? code.slice(2) : code.slice(1);

const buildCodeTypeMaps = (evalData) => {
  const outOfScope = new Set(
    (evalData?.coder_review_required_out_off_scope?.codes || []).map(
      (c) => c.code_assigned,
    ),
  );
  const partial = new Set(
    (evalData?.coder_review_required_partial?.codes || []).map(
      (c) => c.code_assigned,
    ),
  );
  const inScope = new Set(
    (evalData?.coder_review_required_in_scope?.codes || []).map(
      (c) => c.code_assigned,
    ),
  );

  const isEmpty =
    outOfScope.size === 0 && partial.size === 0 && inScope.size === 0;

  return { outOfScope, partial, inScope, isEmpty };
};

const resolveCodeType = (rawCode, isProcedure, maps) => {
  // Evaluation came back with nothing flagged at all → clear this code's color
  if (maps.isEmpty) return null;

  const key = isProcedure ? rawCode : normalizeDiagnosisCode(rawCode);
  if (maps.outOfScope.has(key)) return "Out Off scope";
  if (maps.partial.has(key)) return "Partial";
  if (maps.inScope.has(key)) return "In scope";
  return undefined; // not mentioned in a non-empty response — leave untouched
};

// Re-color codes every time a fresh nudging evaluation comes back
useEffect(() => {
  if (!data?.data) return;
  if (typeof setDiagnosisStates !== "function") return;

  const maps = buildCodeTypeMaps(data.data);

  setDiagnosisStates((prev) => {
    if (!prev) return prev;

    let anyChanged = false;

  const updateList = (list, isProcedure) => {
  if (!Array.isArray(list) || list.length === 0) return list;

  let listChanged = false;
  const next = list.map((item) => {
    if (!item?.code) return item;
    const newType = resolveCodeType(item.code, isProcedure, maps);

    // undefined = code wasn't in this nudge response at all → leave as-is
    if (newType === undefined) return item;

    if (newType !== item.code_type) {
      listChanged = true;
      return { ...item, code_type: newType };
    }
    return item;
  });

  if (!listChanged) return list;
  anyChanged = true;
  return next;
};

    const principal = updateList(prev.principal, false);
    const additional = updateList(prev.additional, false);
    const procedure = updateList(prev.procedure, true);

    // Nothing changed at all → return the SAME prev object.
    // This is critical: React/Redux consumers relying on reference
    // equality won't re-render or re-fire effects.
    if (!anyChanged) return prev;

    return { ...prev, principal, additional, procedure };
  });
}, [data, setDiagnosisStates]);
  return (
    <>
      <ToastContainer position="top-center" autoClose={3000} />
      <div className="nudge-panel">
        <div className="nudge-panel-header">
          <div className="nudge-panel-header-left">
            <InfoOutlinedIcon className="nudge-panel-info-icon" />
            <span className="nudge-panel-title">
              Nudges | {totalVisibleNudgeCount} available
            </span>
          </div>
          <button
            className="nudge-panel-close"
            onClick={onClose}
            aria-label="Close"
          >
            <img src={closeIcon} alt="close" />
          </button>
        </div>

        <div className="nudge-list">
          {loading ? (
            <div className="nudge-empty-state">
              <LdsRoller />
            </div>
          ) : visibleNudges.length === 0 ? (
            <div className="nudge-empty-state">No nudges available.</div>
          ) : (
            visibleNudges.map((item) => {
              const expanded = expandedId === item.id;
              let nudgeColor = "";
              if (item.theme === "review") {
                if (item.reviewType === "out_of_scope_code") {
                  nudgeColor = "#DC2626";
                }
                if (item.reviewType === "partial_match_code") {
                  nudgeColor = "#F97316";
                }
              }
              const currentPage = getCurrentPage(item);
              const currentCode = item.codes?.[currentPage];
              const totalItems = item.codes?.length || 0;
              const hasPrevious = currentPage > 0;
              const hasNext = currentPage < totalItems - 1;

              return (
                <div
                  key={item.id}
                  className={`nudge-item theme-${item.theme} ${
                    expanded ? "expanded" : ""
                  }`}
                >
                  <button
                    className="nudge-item-header"
                    onClick={() => setExpandedId(expanded ? null : item.id)}
                    style={{
                      color: nudgeColor,
                      cursor: "pointer",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        width: "100%",
                      }}
                    >
                      <span
                        className="nudge-item-icon"
                        style={{
                          color: nudgeColor,
                        }}
                      >
                        {item.icon}
                      </span>

                      <span
                        className="nudge-item-title"
                        style={{
                          color: nudgeColor,
                        }}
                      >
                        {item.title}
                      </span>

                      {shouldShowUndo(item) && (
                        <div
                          className="nudge-undo-container"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            marginLeft: "8px",
                          }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          {/* <span
                            className="nudge-undo"
                            style={{
                              color: "#fff",
                              background: nudgeColor,
                              cursor: "pointer",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleUndoNudge(item);
                            }}
                          >
                            undo
                          </span> */}
                          <button
                            className="nudge-undo"
                            // style={{
                            // color: "#fff",
                            // background: nudgeColor,
                            // cursor: "pointer",
                            // }}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleUndoNudge(item);
                            }}
                            // className="undo-button"
                          >
                            <img
                              className="undo-icon"
                              src={undo_icon}
                              alt="undo"
                            />
                          </button>

                          <span className="nudge-undo-timer">
                            {undoTimers[item.id]}s
                          </span>
                        </div>
                      )}
                    </div>

                    <div>
                      <ArrowDropDownIcon
                        className={`nudge-item-chevron ${
                          expanded ? "rotated" : ""
                        }`}
                      />
                    </div>
                  </button>
                 
                  {expanded && (
                    <div className="nudge-item-body">
                      {/* ---- Revenue Optimisation layout ---- */}
                      {item.theme === "revenue" &&
                        item.reviewType === "revenue-optimization" && (
                          <>
                            <div className="nudge-detail-row">
                              {console.log("Nudge Item:", item)}
                              <span className="nudge-detail-label">
                                CURRENT DRG
                              </span>
                              <span className="nudge-detail-value">
                                {item.currentDrg}
                              </span>
                            </div>
                            <div className="nudge-detail-row">
                              <span className="nudge-detail-label">
                                SUGGESTED DRG
                              </span>
                              <span className="nudge-detail-value">
                                {item.suggestedDrg}
                              </span>
                            </div>

                            {/* {item.estimatedIncrease && ( */}
                            <div className="nudge-banner theme-revenue">
                              {item.estimatedIncrease
                                ? `${item.estimatedIncrease} Estimated ${
                                    String(item.estimatedIncrease).startsWith(
                                      "-",
                                    )
                                      ? "Decrease"
                                      : "Increase"
                                  }`
                                : "+$0 Estimated Increase"}
                            </div>
                            {/* )} */}

                            <p className="nudge-text-reason">
                              Reason: {item.reason}
                            </p>
                            <p className="nudge-label-small block">
                              {item.evidenceLabel} {item.evidence}
                            </p>
                            {/* Revenue Pagination */}
                            {totalItems > 1 && (
                              <div className="nudge-pagination">
                                <button
                                  className="nudge-pagination-btn"
                                  disabled={!hasPrevious}
                                  onClick={() =>
                                    setCurrentPage(item, currentPage - 1)
                                  }
                                >
                                  Previous
                                </button>
                                <span className="nudge-pagination-info">
                                  {currentPage + 1} / {totalItems}
                                </span>

                                <button
                                  className="nudge-pagination-btn"
                                  disabled={!hasNext}
                                  onClick={() =>
                                    setCurrentPage(item, currentPage + 1)
                                  }
                                >
                                  Next
                                </button>
                              </div>
                            )}
                            {/* {item.suggestedAction && (
                          <div className="nudge-suggested-action">
                            <strong>
                              Suggested Action:
                            </strong>{" "}
                            {item.suggestedAction}
                          </div>
                        )} */}
                          </>
                        )}

                      {/* ---- Coder Review layout ---- */}
                      {item.theme === "review" &&
                        item.reviewType === "out_of_scope_code" && (
                          <>
                            {totalItems === 0 ? (
                              <div className="nudge-no-data">
                                No out-of-scope codes found.
                              </div>
                            ) : (
                              <>
                                <div className="nudge-label-block">
                                  {/* <span className="nudge-label-small">CODE ASSIGNED:</span> */}
                                  <span className="nudge-label-small-value">
                                    CODE ASSIGNED:{" "}
                                    {currentCode?.code_assigned || "N/A"}
                                    {currentCode?.code_description
                                      ? ` ${currentCode.code_description}`
                                      : ""}
                                  </span>
                                </div>

                                <p
                                  className="nudge-text-reason"
                                  style={{
                                    color: nudgeColor,
                                  }}
                                >
                                  {/* <strong> */}
                                  Reason:
                                  {/* </strong>{" "} */}
                                  {item.reason}
                                </p>

                                <span className="nudge-label-small block">
                                  {item.evidenceLabel}
                                </span>
                                <p className="nudge-text">
                                  {currentCode?.evidence_from_documentation ||
                                    "No documentation evidence available."}
                                </p>
                                <div className="nudge-pagination">
                                  <button
                                    className="nudge-pagination-btn"
                                    disabled={!hasPrevious}
                                    onClick={() =>
                                      setCurrentPage(item, currentPage - 1)
                                    }
                                  >
                                    Previous
                                  </button>
                                  <span className="nudge-pagination-info">
                                    {currentPage + 1} / {totalItems}
                                  </span>

                                  <button
                                    className="nudge-pagination-btn"
                                    disabled={!hasNext}
                                    onClick={() =>
                                      setCurrentPage(item, currentPage + 1)
                                    }
                                  >
                                    Next
                                  </button>
                                </div>
                              </>
                            )}

                            {/* SUGGESTED ACTION */}

                            <div className="nudge-suggested-action">
                              <strong>Suggested Action:</strong>{" "}
                              {item.suggestedAction}
                            </div>
                            {item.showViewSource && (
                              <a
                                href="#"
                                className="nudge-view-source"
                                disabled={totalItems === 0}
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleCodeClick(
                                    "view_source",
                                    item,
                                    currentCode,
                                  );
                                }}
                              >
                                View Source
                              </a>
                            )}
                          </>
                        )}

                      {item.theme === "review" &&
                        item.reviewType === "partial_match_code" && (
                          <>
                            {totalItems === 0 ? (
                              <div className="nudge-no-data">
                                No partial match codes found.
                              </div>
                            ) : (
                              <>
                                <div className="nudge-label-block">
                                  {/* <span className="nudge-label-small">CODE ASSIGNED:</span> */}
                                  <span className="nudge-label-small-value">
                                    CODE ASSIGNED:{" "}
                                    {currentCode?.code_assigned || "N/A"}
                                    {currentCode?.code_description
                                      ? ` ${currentCode.code_description}`
                                      : ""}
                                  </span>
                                </div>

                                <p
                                  className="nudge-text-reason"
                                  style={{
                                    color: nudgeColor,
                                  }}
                                >
                                  {/* <strong> */}
                                  Reason:
                                  {/* </strong>{" "} */}
                                  {item.reason}
                                </p>

                                <span className="nudge-label-small block">
                                  {item.evidenceLabel}
                                </span>

                                <p className="nudge-text">
                                  {currentCode?.evidence_from_documentation ||
                                    "No documentation evidence available."}
                                </p>

                                <div className="nudge-pagination">
                                  <button
                                    className="nudge-pagination-btn"
                                    disabled={!hasPrevious}
                                    onClick={() =>
                                      setCurrentPage(item, currentPage - 1)
                                    }
                                  >
                                    Previous
                                  </button>

                                  <span className="nudge-pagination-info">
                                    {currentPage + 1} / {totalItems}
                                  </span>

                                  <button
                                    className="nudge-pagination-btn"
                                    disabled={!hasNext}
                                    onClick={() =>
                                      setCurrentPage(item, currentPage + 1)
                                    }
                                  >
                                    Next
                                  </button>
                                </div>
                              </>
                            )}

                            <div className="nudge-suggested-action">
                              <strong>Suggested Action:</strong>{" "}
                              {item.suggestedAction}
                            </div>

                            {item.showViewSource && (
                              <a
                                href="#"
                                className="nudge-view-source"
                                 onClick={(e) => {
                                  e.preventDefault();
                                  handleCodeClick(
                                    "view_source",
                                    item,
                                    currentCode,
                                  );
                                }}
                              >
                                View Source
                              </a>
                            )}
                          </>
                        )}
                      {/* ---- Common Code Combination layout ---- */}
                      {item.theme === "combo" && (
                        <>
                          <div className="nudge-label-block">
                            <span className="nudge-label-small">CURRENT:</span>
                            <span className="nudge-label-small-value">
                              {item.currentCode}
                            </span>
                          </div>

                          <div className="nudge-banner theme-combo">
                            Suggest: {item.suggestedCode}
                          </div>

                          <p className="nudge-text">Reason: {item.reason}</p>
                          <p className="nudge-text">
                            <strong>{item.evidenceLabel}</strong>{" "}
                            {item.evidence}
                          </p>

                          {item.suggestedAction && (
                            <div className="nudge-suggested-action">
                              <strong>Suggested Action:</strong>{" "}
                              {item.suggestedAction}
                            </div>
                          )}
                        </>
                      )}

                      <div className="nudge-actions">
                        <button
                          className="nudge-btn-accept"
                          disabled={totalItems === 0 || acceptingId === item.id}
                          onClick={() =>
                            handleCodeClick("accept", item, currentCode)
                          }
                        >
                          {acceptingId === item.id ? "Accepting..." : "Accept"}
                        </button>
                        <button
                          className="nudge-btn-review"
                          disabled={totalItems === 0}
                          onClick={() =>
                            handleCodeClick("view_codebook", item, currentCode)
                          }
                        >
                          Review in Codebook
                        </button>
                        <button
                          className="nudge-btn-dismiss"
                          aria-label="Dismiss"
                          disabled={
                            totalItems === 0 || !!dismissedNudges[item.id]
                          }
                          onClick={() => handleDismissNudge(item, currentCode)}
                        >
                          {" "}
                          ×{" "}
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              );
            })
          )}
        </div>
      </div>
    </>
  );
}
